import {ChangeDetectionStrategy, Component, computed, Inject, input, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';

import {DATE_FORMAT} from '@app/api/constants';

import {User} from '@app/api/models/user';
import {Survey} from '@app/api/models/survey';
import {ExclusionPreference, ExclusionPreferenceRequest} from '@app/api/models/preference';
import {PreferenceService} from '@app/api/services/preference.service';
import {
  ConfirmationDialogComponent
} from '@app/components/general-purpose/dialogs/confirmation-dialog/confirmation-dialog.component';
import {DateRangePipe} from '../../../../pipes/date-range.pipe';
import {
  WaBadgeDirective,
  WaButtonDirective,
  WaCardDirective,
  WaIconDirective,
  WaTagDirective,
  WaToastService
} from "angular-awesome";
import {ExclusionPreferenceDialogComponent} from "../exclusion-preference-dialog/exclusion-preference-dialog.component";
import {Dialog} from "@angular/cdk/dialog";
import {rxResource} from "@angular/core/rxjs-interop";

@Component({
  standalone: true,
  selector: 'app-preference-list',
  templateUrl: './preference-list.component.html',
  styleUrls: ['./preference-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DateRangePipe, WaButtonDirective, WaCardDirective, WaIconDirective, WaTagDirective, WaBadgeDirective]
})
export class PreferenceListComponent implements OnInit {

  user = input.required<User>();
  survey = input.required<Survey>();

  preference_params = computed(() => ({
    survey_id: this.survey().id,
    user_id: this.user().id,
  }));

  exclusionPreferences = rxResource({
    params: this.preference_params,
    stream: ({params}) => this.prefService.getExclusionPreferences(params.survey_id, params.user_id),
  });

  // ExclusionPreferences as a readonly view sorted by start date, then end date
  exclusionPreferenceView = computed<ExclusionPreference[] | undefined>(() => this.exclusionPreferences.hasValue() ? this.exclusionPreferences.value().toSorted((a, b) => {
    const a_start = new Date(a.begin);
    const b_start = new Date(b.begin);
    if (a_start.getTime() - b_start.getTime() !== 0) {
      return a_start.getTime() - b_start.getTime();
    }

    const a_end = new Date(a.end);
    const b_end = new Date(b.end);
    return a_end.getTime() - b_end.getTime();
  }) : undefined);


  step: number = 2;

  //langPrefs: LanguagePreference[] = [];
  //locPrefs: LocationPreference[] = [];

  //fieldPrefs: FieldPreference[] = [];

  constructor(private dialog: Dialog,
              private datePipe: DatePipe,
              private toastService: WaToastService,
              private prefService: PreferenceService,
              @Inject(DATE_FORMAT) public dateFormat: string) {
  }


  voting_upcoming = false
  voting_ongoing = false
  voting_ended = false

  ngOnInit(): void {
    const now = new Date;
    now.setHours(0, 0, 0, 0)     // otherwise "now" is today's date at the current time
    const begin = new Date(this.survey().begin);
    const end = new Date(this.survey().end);

    console.log("Date today " + now)
    console.log("Date begin " + begin)
    console.log("Date end " + end)

    if (begin <= now && now <= end) {
      this.voting_ongoing = true;
      this.voting_upcoming = false;
      this.voting_ended = false;
    } else if (begin > now) {
      this.voting_ongoing = false;
      this.voting_upcoming = true;
      this.voting_ended = false
    } else {
      this.voting_ongoing = false;
      this.voting_upcoming = false;
      this.voting_ended = true
    }
  }


  ngOnChanges()
    :
    void {
    // if (!this.user || !this.survey) {
    //   this.langPrefs = [];
    //   this.locPrefs = [];
    //   this.exclPrefs = [];
    //   this.fieldPrefs = [];
    //   return;
    // }
    //
    // this.getPreferences(this.survey.id, this.user.id);
  }

// private getPreferences(surveyId: number, userId: number): void {
//   this.getLanguagePreferences(surveyId, userId);
//   this.getLocationPreferences(surveyId, userId);
//   this.getExclusionPreferences(surveyId, userId);
//   this.getFieldPreferences(surveyId, userId);
// }
//
// private getLanguagePreferences(surveyId: number, userId: number): void {
//   this.prefService.getLangPrefs(surveyId, userId).subscribe({
//     next: prefs => this.langPrefs = prefs,
//     error: err => {
//       this.msgService.log(err.message);
//       this.msgService.showSimple('Could not fetch language preferences.');
//     }
//   });
// }
//
// private getLocationPreferences(surveyId: number, userId: number): void {
//   this.prefService.getLocPrefs(surveyId, userId).subscribe({
//     next: prefs => this.locPrefs = prefs,
//     error: err => {
//       this.msgService.log(err.message);
//       this.msgService.showSimple('Could not fetch location preferences.');
//     }
//   });
// }

// private getExclusionPreferences(surveyId: number, userId: number): void {
//   this.prefService.getExclusionPreferences(surveyId, userId).subscribe({
//     next: prefs => this.exclPrefs = prefs,
//     error: err => {
//       this.msgService.log(err.message);
//       this.msgService.showSimple('Could not fetch exclusion preferences.');
//     }
//   });
// }

// private getFieldPreferences(surveyId: number, userId: number): void {
//   this.prefService.getFieldPrefs(surveyId, userId).subscribe({
//     next: prefs => this.fieldPrefs = prefs,
//     error: err => {
//       this.msgService.log(err.message);
//       this.msgService.showSimple('Could not fetch field preferences.');
//     }
//   });
// }

// getFlagClass(languageName: string): string {
//   return getFlagClass(languageName);
// }

  surveyActive()
    :
    boolean {
    const survey = this.survey();

    if (!survey)
      return false;

    const from = new Date(survey.begin).setUTCHours(0, 0, 0);
    const to = new Date(survey.end).setUTCHours(23, 59, 59);
    const now = new Date;

    return from <= now.getTime() && now.getTime() <= to;
  }

  addExclusionPreferenceDialog()
    :
    void {
    const user = this.user();
    const survey = this.survey();

    if (!
      user || !survey || !this.surveyActive()
    )
      return;

    const ref = this.dialog.open<ExclusionPreferenceRequest | null>(ExclusionPreferenceDialogComponent, {
      disableClose: true,
      data: {
        user: this.user(),
        survey: this.survey(),
      }
    });

    ref.closed.subscribe(data => {
      if (!data)
        return;

      const pref = data;

      if (!pref)
        return;
      console.log(pref);
      this.prefService.createExclusionPreference(pref).subscribe((newPref) => this.exclusionPreferences.update((prefs) => prefs ? [...prefs, newPref] : [newPref]));
    });
  }

// deleteLanguagePreference(pref: LanguagePreference): void {
//   const ref = this.dialog.open(ConfirmationDialogComponent, {
//     disableClose: true,
//     data: {
//       title: 'Confirm deletion',
//       message: `Are you sure that you want to delete your preference for ${pref.language.name}?`
//     }
//   });
//
//   ref.closed.subscribe({
//     next: data => {
//       if (!data) return;
//       this.prefService.deleteLangPref(pref.id).subscribe(() => {
//         this.langPrefs = this.langPrefs.filter(elt => elt !== pref);
//       });
//     },
//     error: err => {
//       this.msgService.log(err.message);
//       this.msgService.showSimple('Could not delete language preference.');
//     }
//   });
// }
//
// deleteLocationPreference(pref: LocationPreference): void {
//   const ref = this.dialog.open(ConfirmationDialogComponent, {
//     disableClose: true,
//     data: {
//       title: 'Confirm deletion',
//       message: `Are you sure that you want to delete your preference for ${pref.location.name}?`
//     }
//   });
//
//   ref.closed.subscribe({
//     next: data => {
//       if (!data) return;
//       this.prefService.deleteLocPref(pref.id).subscribe(() => {
//         this.locPrefs = this.locPrefs.filter(elt => elt !== pref);
//       });
//     },
//     error: err => {
//       this.msgService.log(err.message);
//       this.msgService.showSimple('Could not delete location preference.');
//     }
//   });
// }

  deleteExclusionPreference(pref
                            :
                            ExclusionPreference
  ):
    void {
    const begin = this.datePipe.transform(pref.begin, this.dateFormat);
    const end = this.datePipe.transform(pref.end, this.dateFormat);
    const note = pref.note;
    const ref = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        title: 'Confirm deletion',
        message: `Are you sure that you want to delete the excluded time period ${begin} — ${end}${note !== null ? ' "' + note + '"' : ''} ?`,
        cancel_button: true
      }
    });

    ref.closed.subscribe({
      next: data => {
        if (!data) return;
        this.prefService.deleteExclusionPreference(pref.id).subscribe(() => {
          this.exclusionPreferences.update((prefs) => prefs?.filter(item => item !== pref));
        });
      },
      error: err => {
        this.toastService.danger('Could not delete exclusion preference.');
      }
    });
  }

// deleteFieldPreference(pref: FieldPreference): void {
//   const ref = this.dialog.open(ConfirmationDialogComponent, {
//     disableClose: true,
//     data: {
//       title: 'Confirm deletion',
//       message: `Are you sure that you want to delete your preference for ${pref.field.name}?`
//     }
//   });
//
//   ref.closed.subscribe({
//     next: data => {
//       if (!data) return;
//       this.prefService.deleteFieldPref(pref.id).subscribe(() => {
//         this.fieldPrefs = this.fieldPrefs.filter(elt => elt !== pref);
//       });
//     },
//     error: err => {
//       this.msgService.log(err.message);
//       this.msgService.showSimple('Could not delete field preference.');
//     }
//   });
// }
}
